export const WCC_PPD_PANEL = 'WCC_PPD_PANEL'
export const WCC_PTTEXT_PANEL = 'WCC_PTTEXT_PANEL'
export const WCC_AWARDS_PANEL = 'WCC_AWARDS_PANEL'
export const WCC_ADDRESS_PANEL = 'WCC_ADDRESS_PANEL'
export const WCC_DATE_PANEL = 'WCC_DATE_PANEL'
export const WCC_DEPENDENTS_PANEL = 'WCC_DEPS_PANEL'

export const WCC_HEARING_LOCATION_LOOKUP_TYPE = 'hearingLocations'
export const WCC_DISABILITY_TYPES_LOOKUP_TYPE = 'disabilityTypes'
export const WCC_COURT_REPORTERS_LOOKUP_TYPE = 'courtReporters'
export const WCC_ONBEHALFOF_CHOICES_LOOKUP_TYPE = 'onBehalfOf'

export const WCC_CURRENT_DATE = 'CURRENT_DATE'
export const WCC_ADVANCE_BY_ONE_MONTH = 'ADVANCE_BY_ONE_MONTH'
export const WCC_ADVANCE_BY_ONE_YEAR = 'ADVANCE_BY_ONE_YEAR'

export const WCC_A4_PAGE_SIZE = 1056
export const WCC_EDITOR_CONTENT_BANNER_GREET = () =>
    new Date().getHours() >= 12 ? 'Good Afternoon' : 'Good Morning'

export const WCC_EDITOR_DEFAULT_CONTENT = (param) => `
   <div contenteditable="false" class="w-default-label" style=text-align:center>
      <h5>${WCC_EDITOR_CONTENT_BANNER_GREET()}, ${param}!</h5>
      <h6>Select the template or document to generate the order.</h6>
   </div>`

// attorney and medical providers constants
export const WCC_ATTORNEYS_MEDICAL_PROVIDERS_CONTROL_KEY =
    'wcc-attorneys-medical-providers-state'
export const WCC_ATTORNEYS_STATE_KEY = 'attorneys_state'
export const WCC_MEDICAL_PROVIDERS_STATE_KEY = 'medical_providers_state'

// permanent partial disability constants
export const WCC_PPD_CONTROL_KEY = 'wcc-permanent-partial-state'
export const WCC_PPD_BODY_PARTS_STATE_KEY = 'body_parts'
export const WCC_PPD_AUDIT_CONTROLS = 'wcc-permanent-partial-audit-controls'

// permanent partial text constants
export const WCC_PPTEXT_CONTROL_KEY = 'wcc-permanent-partial-text-state'
export const WCC_PPTEXT_BODY_PARTS_STATE_KEY = 'pptext_body_parts'
export const WCC_PPTEXT_RESULT_STATE_KEY = 'pptext_result'

// dependants panel constants
export const WCC_DEPENDANTS_CONTROL_KEY = 'wcc-dependants-panel-state'
export const WCC_DEPENDANTS_STATE_KEY = 'dependants_state'

export const WCC_COMMISSIONER_SIGNATURE_CONTROL_KEY =
    'wcc-commissioner-signature-state'

export const fonts = [
    'Arial',
    'Bookman Old Style',
    'Georgia',
    'Times New Roman',
    'Verdana',
] // Array of available fonts.

export const fontSizes = ['1', '2', '3', '4'] //Array of available font sizes

export const MULTIPLE_VALUES_DELIMITER = '#~#'

export const WCC_EXIT_MODAL_SAVE_CHANGES_YES = 'YES'
export const WCC_EXIT_MODAL_SAVE_CHANGES_NO = 'NO'

export const WCC_TEMPLATE_PLACEHOLDER = 'wcc-template-placeholder'

export const activeStylesDefaults = {
    hasSelection: false,
    fontFamily: 'Bookman Old Style',
    fontSize: '2',
    bold: false,
    italic: false,
    underline: false,
    insertUnorderedList: false,
    insertOrderedList: false,
    justifyLeft: false,
    justifyCenter: false,
    justifyRight: false,
    justifyFull: false,
    lineHeight: '1.25',
}

export const setOrGetDefaultPanelResult = (controls) => {
    return {
        state: {
            [WCC_ATTORNEYS_MEDICAL_PROVIDERS_CONTROL_KEY]: {
                [WCC_ATTORNEYS_STATE_KEY]:
                    controls?.[WCC_ATTORNEYS_MEDICAL_PROVIDERS_CONTROL_KEY]
                        ?.value?.state[WCC_ATTORNEYS_STATE_KEY] || [],
                [WCC_MEDICAL_PROVIDERS_STATE_KEY]:
                    controls?.[WCC_ATTORNEYS_MEDICAL_PROVIDERS_CONTROL_KEY]
                        ?.value?.state[WCC_MEDICAL_PROVIDERS_STATE_KEY] || [],
            },
            [WCC_PPD_CONTROL_KEY]: {
                [WCC_PPD_BODY_PARTS_STATE_KEY]:
                    controls?.[WCC_PPD_CONTROL_KEY]?.value?.state[
                    WCC_PPD_BODY_PARTS_STATE_KEY
                    ] || [],
            },
            [WCC_PPTEXT_CONTROL_KEY]: {
                [WCC_PPTEXT_BODY_PARTS_STATE_KEY]:
                    controls?.[WCC_PPTEXT_CONTROL_KEY]?.value?.state[
                    WCC_PPTEXT_BODY_PARTS_STATE_KEY
                    ] || [],
                [WCC_PPTEXT_RESULT_STATE_KEY]:
                    controls?.[WCC_PPTEXT_CONTROL_KEY]?.value?.state[
                    WCC_PPTEXT_RESULT_STATE_KEY
                    ] || [],
            },
            [WCC_DEPENDANTS_CONTROL_KEY]: {
                [WCC_DEPENDANTS_STATE_KEY]:
                    controls?.[WCC_DEPENDANTS_CONTROL_KEY]?.value?.state[
                    WCC_DEPENDANTS_STATE_KEY
                    ] || {},
            },
        },
    }
}

export const WCC_EMPLOYER_ENTITY_TYPE = 'EMPLOYER'
export const WCC_INSURER_ENTITY_TYPE = 'INSURER'
export const WCC_DEPENDENT_ENTITY_TYPE = 'DEPENDENT'

export const WCC_ADDRESS_LABEL_PAGE_X_POSITION = 80
export const WCC_ADDRESS_LABEL_PAGE_X_LINE4_POSITION = 300
export const WCC_ADDRESS_LABEL_PAGE_Y_POSITION_LINE1 = 64
export const WCC_ADDRESS_LABEL_PAGE_Y_POSITION_LINE2 = 52
export const WCC_ADDRESS_LABEL_PAGE_Y_POSITION_LINE3 = 40
export const WCC_ADDRESS_LABEL_PAGE_Y_POSITION_LINE4 = 5

export const WCC_ATTORNEYS_MEDICAL_PROVIDERS_TEMPLATE_T1 = 'AWARDS_PANEL_T1'
export const WCC_ATTORNEYS_MEDICAL_PROVIDERS_TEMPLATE_T2 = 'AWARDS_PANEL_T2'

export const WCC_ATTORNEY_TEMPLATE_TYPE = 'ATTORNEY'
export const WCC_MEDICAL_PROVIDER_TEMPLATE_TYPE = 'MEDICAL_PROVIDER'

export const WCC_AWARD_TYPE_CONTROL_KEY = 'wcc-award-type'

export const WCC_OBSERVABLE_AWW_FIELD = 'AverageWeeklyWage'
export const WCC_OBSERVABLE_ACCIDENT_DATE_FIELD = 'AccidentDate'
export const WCC_OBSERVABLE_DOCUMENT_DATE_FIELD = 'DocumentDate'
export const WCC_OBSERVABLE_DISABILITY_TYPE_FIELD = 'DisabilityFrom'
export const WCC_OBSERVABLE_COURT_REPORTERS_FIELD = 'CourtReporterName'
export const WCC_OBSERVABLE_RESCIND_ORDER_DATE = 'RescindOrderDate'
export const WCC_OBSERVABLE_REDUCTION_WEEKLY_PAYMENT = 'ReductionWeeklyPayment'
export const WCC_OBSERVABLE_NEW_WEEKLY_RATE = 'NewWeeklyRate'
export const WCC_OBSERVABLE_SD_REDUCTION_WEEKS = 'SDWeeks'
export const WCC_OBSERVABLE_OA_REDUCTION_WEEKS = 'OAReductionWeeks'
export const WCC_OBSERVABLE_TT_TERMINATION_DATE = 'TTTerminateDate'
export const WCC_OBSERVABLE_ACCIDENT_YEAR = 'AccidentYear'
export const WCC_OBSERVABLE_HEARING_AWW = 'HearingAWW'
export const WCC_OBSERVABLE_EARNER_AWW = 'EarnerAWW'
export const WCC_OBSERVABLE_EARNER_AWW1 = 'EarnerAWW1'
export const WCC_OBSERVABLE_EARNER_AWW2 = 'EarnerAWW2'
export const WCC_OBSERVABLE_EARNER_AWW3 = 'EarnerAWW3'
export const WCC_OBSERVABLE_EARNER_AWW4 = 'EarnerAWW4'
export const WCC_OBSERVABLE_EARNER_AWW5 = 'EarnerAWW5'
export const WCC_OBSERVABLE_EARNER_AWW6 = 'EarnerAWW6'
export const WCC_OBSERVABLE_EARNER_AWW7 = 'EarnerAWW7'
export const WCC_OBSERVABLE_EARNER_AWW8 = 'EarnerAWW8'
export const WCC_OBSERVABLE_EARNER_AWW9 = 'EarnerAWW9'
export const WCC_OBSERVABLE_SIF_ORIGINAL_TOTAL = 'SIFOriginalTotal'
export const WCC_OBSERVABLE_SIF_OTHER_AWARD_AMOUNT = 'OtherAwardAmount'

export const WCC_DOCUMENT_EDITOR_OBSERVABLE_FIELDS = [
    WCC_OBSERVABLE_AWW_FIELD,
    WCC_OBSERVABLE_ACCIDENT_DATE_FIELD,
    WCC_OBSERVABLE_DOCUMENT_DATE_FIELD,
    WCC_OBSERVABLE_DISABILITY_TYPE_FIELD,
    WCC_OBSERVABLE_COURT_REPORTERS_FIELD,
    WCC_OBSERVABLE_RESCIND_ORDER_DATE,
    WCC_OBSERVABLE_REDUCTION_WEEKLY_PAYMENT,
    WCC_OBSERVABLE_NEW_WEEKLY_RATE,
    WCC_OBSERVABLE_SD_REDUCTION_WEEKS,
    WCC_OBSERVABLE_OA_REDUCTION_WEEKS,
    WCC_OBSERVABLE_TT_TERMINATION_DATE,
    WCC_OBSERVABLE_ACCIDENT_YEAR,
    WCC_OBSERVABLE_HEARING_AWW,
    WCC_OBSERVABLE_EARNER_AWW,
    WCC_OBSERVABLE_EARNER_AWW1,
    WCC_OBSERVABLE_EARNER_AWW2,
    WCC_OBSERVABLE_EARNER_AWW3,
    WCC_OBSERVABLE_EARNER_AWW4,
    WCC_OBSERVABLE_EARNER_AWW5,
    WCC_OBSERVABLE_EARNER_AWW6,
    WCC_OBSERVABLE_EARNER_AWW7,
    WCC_OBSERVABLE_EARNER_AWW8,
    WCC_OBSERVABLE_EARNER_AWW9,
    WCC_OBSERVABLE_SIF_ORIGINAL_TOTAL,
    WCC_OBSERVABLE_SIF_OTHER_AWARD_AMOUNT,
]

export const WCC_DOCUMENT_PREVIEW_IFRAME_ID = 'wcc-document-preview-iframe'
export const WCC_TEMPLATE_PLACEHOLDER_DEFAULT_INNERHTML =
    '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'

export const WCC_TEMPLATE_IGNORED_KEYS = [
    WCC_COMMISSIONER_SIGNATURE_CONTROL_KEY,
    WCC_ATTORNEYS_MEDICAL_PROVIDERS_CONTROL_KEY,
    WCC_AWARD_TYPE_CONTROL_KEY,
    WCC_PPD_CONTROL_KEY,
    WCC_PPTEXT_CONTROL_KEY,
    WCC_DEPENDANTS_CONTROL_KEY,
]

export const WCC_TEMPLATE_DATE_DEFAULT_FORMAT = 'MMMM d, yyyy'

export const WCC_TEMPLATE_CURRENCY_DISPLAY_FORMAT = 'C'
export const WCC_TEMPLATE_PROPERCASE_DISPLAY_FORMAT = '@ProperCase'
export const WCC_TEMPLATE_UPPERCASE_DISPLAY_FORMAT = '@UpperCase'
export const WCC_TEMPLATE_SSN_DISPLAY_FORMAT = '000-00-0000'
export const WCC_TEMPLATE_MOBILE_DISPLAY_FORMAT = '(###) ###-####'
export const WCC_TEMPLATE_NUMBER_TWO_DECIMALS_FORMAT = '##0.###'
export const WCC_TEMPLATE_NUMBER_THREE_DECIMALS_FORMAT = '##0.###'
export const WCC_TEMPLATE_NUMBER_FIVE_DECIMALS_FORMAT = '##0.#####'
export const WCC_TEMPLATE_NUMBER_THREE_DECIMALS_PERCENT_FORMAT = '##0.###%'

export const WCC_TEMPLATE_CONTROLS_AWARD_ATTORNEY_NAME = 'AWD_AttorneyName'
export const WCC_TEMPLATE_CONTROLS_AWARD_ATTORNEY_COSTS = 'AWD_AttorneyCosts'
export const WCC_TEMPLATE_CONTROLS_AWARD_ATTORNEY_FEES = 'AWD_AttorneyFees'

export const WCC_TEMPLATE_CONTROLS_AWARD_MEDICAL_NAME = 'AWD_MedicalName'
export const WCC_TEMPLATE_CONTROLS_AWARD_MEDICAL_FEES = 'AWD_MedicalFees'

export const WCC_TEMPLATE_PLACEHOLDER_ZWS = '\u2060'

export const WCC_TEMPLATE_AWARD_TYPE_FIELD_NAME = 'AwardType'
export const WCC_TEMPLATE_EMPLOYER_FIELD_NAME = 'Employer'
export const WCC_TEMPLATE_INSURER_FIELD_NAME = 'Insurer'
export const WCC_TEMPLATE_DEPENDENT_FIELD_NAME = 'DependentName'
export const WCC_TEMPLATE_RELATIONSHIP_FIELD_NAME = 'Relationship'
export const WCC_TEMPLATE_DEPENDENT_DOB_FIELD_NAME = 'DependentDOB'
export const WCC_TEMPLATE_DEPENDENT_AWW_FIELD_NAME =
    'DependentAverageWeeklyWage'

/**
 * Regex to validate WCC claim numbers. 
 * A valid WCC claim number starts with a letter followed by six digits (e.g., A123456).
 * No other special characters or spaces are allowed.
 */
export const WCC_TEMPLATE_CLAIM_NUMBER_REGEX = /^[a-zA-Z]\d{6}$/

export const WCC_TEMPLATE_DISABILITY_TYPE_ACCIDENTAL_INJURY = 'accidental injury'
export const WCC_TEMPLATE_DISABILITY_TYPE_PREEXISTING = 'pre-existing'
export const WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DEAFNESS = 'occupational deafness'
export const WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DISEASE = 'occupational disease'

export const WCC_TEMPLATE_DISABILITY_TYPE_ACCIDENTAL_INJURY_OR_PREEXISTING_DESCRIPTION = ' sustained on'
export const WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DEAFNESS_DESCRIPTION = ', first date of compensable hearing loss,'
export const WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DISEASE_DESCRIPTION = ', first date of disablement,'

export const WCC_TEMPLATE_DISABILITY_TYPE_AND_DESCRIPTION_MAP = {
    [WCC_TEMPLATE_DISABILITY_TYPE_ACCIDENTAL_INJURY]: WCC_TEMPLATE_DISABILITY_TYPE_ACCIDENTAL_INJURY_OR_PREEXISTING_DESCRIPTION,
    [WCC_TEMPLATE_DISABILITY_TYPE_PREEXISTING]: WCC_TEMPLATE_DISABILITY_TYPE_ACCIDENTAL_INJURY_OR_PREEXISTING_DESCRIPTION,
    [WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DEAFNESS]: WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DEAFNESS_DESCRIPTION,
    [WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DISEASE]: WCC_TEMPLATE_DISABILITY_TYPE_OCCUPATIONAL_DISEASE_DESCRIPTION,
}

export const WCC_TEMPLATE_DISABILITY_TYPE_ADDITIONAL_TEXT_QUERY_SELECTOR = '[data-type="text-hidden"][data-claim-key="DisabilityTypeAdditionalText"]'

export const WCC_TEMPLATE_AVERAGE_WEEKLY_WAGE_KEY = 'wcc-average-weekly-wage'
export const WCC_TEMPLATE_SUSTAINED_DATE_KEY = 'wcc-sustained-date'
